import Registry from "../plugins/Registry";

export default class Gallery {
    static get(selector) {
        let instance = Registry.get('Loader', selector);
        if (instance)
            return instance;

        instance = new Gallery(selector);
        Registry.set('Gallery', selector, instance);

        return instance;
    }

    constructor(selector) {
        this.obj = (typeof selector === 'string') ? $(selector) : selector;
        this.id = this.obj.get(0).id;
        this.selector = '#' + this.id;

        this.list = {};
        this.list.main = this.obj.find('.gallery__list_main');
        this.list.slider = this.obj.find('.gallery__list_slider');

        this.items = {};
        this.items.main = this.list.main.find('[data-gallery-index]');
        this.items.slider = this.list.slider.find('.gallery__list-item');

        this.slider = {};
        this.slider.container = this.obj.find('.gallery__slider');
        this.slider.counter = this.obj.find('.gallery__slider-count span');
        this.slider.closer = this.obj.find('.gallery__slider-closer');
        this.slider.options = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<div class="slick__arrow slick__arrow-prev slick__arrow_light">' +
                '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"' +
                ' viewBox="0 0 59.414 59.414" style="enable-background:new 0 0 59.414 59.414;" xml:space="preserve" fill="#333">' +
                '<polygon points="43.854,59.414 14.146,29.707 43.854,0 45.268,1.414 16.975,29.707 45.268,58 "/>' +
                '</svg>' +
                '</div>',
            nextArrow: '<div class="slick__arrow slick__arrow-next slick__arrow_light">' +
                '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"' +
                ' viewBox="0 0 59.414 59.414" style="enable-background:new 0 0 59.414 59.414;" xml:space="preserve" fill="#333">' +
                '<polygon points="15.561,59.414 14.146,58 42.439,29.707 14.146,1.414 15.561,0 45.268,29.707 "/>' +
                '</svg>' +
                '</div>',
        };

        this.init();
    }

    init() {
        this.setEvents();
    }

    setEvents() {
        this.slider.container.slick(this.slider.options);
        this.slider.container.on('afterChange', (event, slick, currentSlide) => {
            this.slider.counter.text(currentSlide + 1);
        });

        this.items.main.on('click', (e) => this.onMainItemsClick(e));
        this.slider.closer.on('click', (e) => this.onCloserClick(e));

        return this;
    }

    onMainItemsClick(e) {
        e.preventDefault();
        const index = $(e.target).parents('[data-gallery-index]').data('gallery-index');
        this.slider.container.slick('slickGoTo', index);
        this.showSlider();
    }

    onCloserClick(e) {
        e.preventDefault();
        this.closeSlider();
    }

    showSlider() {
        this.list.slider.addClass('show');

        setTimeout(()=> {
            $('html, body').addClass('no-scroll');
        }, 250);
    }

    closeSlider() {
        this.list.slider.removeClass('show');
        $('html, body').removeClass('no-scroll')
            .animate({
                scrollTop: this.obj.offset().top - $('.header').height() - $('.model-menu').height()
            }, 0);
    }

}